var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ontick-div',{class:[!_vm.noBackground ? 'shadow' : '', 'col-span-12']},[_c('table',{class:[
      !_vm.noBackground ? 'bg-ontick-graphite-500' : '',
      _vm.head ? ' w-full' : '',
      _vm.fixed ? 'table-fixed' : 'table-auto',
      'divide-ontick-graphite-700 min-w-full divide-y-2 overflow-x-auto overflow-y-hidden rounded-lg ',
    ]},[_c('thead',[_vm._t("head")],2),_c("transition-group",{tag:"tbody",staticClass:"divide-ontick-graphite-700 divide-y",attrs:{"name":"fruit-table"}},[_vm._t("body")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }